import ModalConfirm from './modal-confirm.container'

export default ModalConfirm